export const MIN_BOUND_PERCENTAGE = 5
export const MAX_BOUND_PERCENTAGE = 95

export const MAX_GROUP_SIZE = 6
